/** "5 steps completed" — the work behind an answer, counted in breadcrumbs
 *  rather than turns, since a turn is an implementation detail the reader has
 *  no way to see. User-visible copy both apps must render identically. */
export const stepsLabel = (count: number) => `${count} step${count === 1 ? "" : "s"} completed`;
